import { PositionsService } from "@common/client"
import { makeAxiosMutation, makeQuery } from "./utils"

export type PositionOwner =
  | { team_id: string }
  | { department_id: string }
  | { facility_id: string }

export const positionsBaseKey = ["positions"] as const

export const positionsQuery = makeQuery({
  serviceCall: (owner: PositionOwner) => PositionsService.listPositions(owner),
  queryKey: (owner) => [...positionsBaseKey, owner],
})

export const useCreatePositionMutation = makeAxiosMutation({
  serviceCall: PositionsService.create,
  invalidates: () => [positionsBaseKey],
})

export const useUpdatePositionMutation = makeAxiosMutation({
  serviceCall: PositionsService.update,
  invalidates: () => [positionsBaseKey],
})

export const useDeletePositionMutation = makeAxiosMutation({
  serviceCall: PositionsService.delete,
  invalidates: () => [positionsBaseKey],
})
